import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-5 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold font-heading text-white whitespace-nowrap">
                桃花视频
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-400 mb-5">
              桃花盛开处，精彩永不断。海量高清影视资源，免费在线观看，流畅不缓冲，追剧观影首选平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-5">视频分类</h4>
            <ul className="space-y-3">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-5">快速链接</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/category/hot" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门推荐</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">最新电影</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热播剧集</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-5">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@taohuavideo.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base mt-0.5 shrink-0"></i>
                <span>北京市朝阳区望京科技园桃花大厦18层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2018-2024 桃花视频 TaohuaVideo.com 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">版权声明</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}